export function formatTimeCs(cs) {
  if (cs === null || cs === undefined) return "—";
  const total = Math.max(0, Math.round(cs));
  const m = Math.floor(total / 6000);
  const rem = total % 6000;
  const s = Math.floor(rem / 100);
  const c = rem % 100;
  return `${m}:${String(s).padStart(2, "0")}.${String(c).padStart(2, "0")}`;
}

export function parseTimeCs(str) {
  if (str === null || str === undefined) return null;
  const t = String(str).trim();
  if (t === "") return null;
  const m = t.match(/^(?:(\d+):)?(\d{1,2})(?:[.,](\d{1,2}))?$/);
  if (!m) return null;
  const min = m[1] ? parseInt(m[1], 10) : 0;
  const sec = parseInt(m[2], 10);
  let cc = m[3] ? m[3] : "0";
  if (cc.length === 1) cc = cc + "0";
  return min * 6000 + sec * 100 + parseInt(cc, 10);
}
